export default __webpack_public_path__ + "static/brutus2-bc8d7bfe2a2dd3cba47cfff5f5f1567b.jpg";